import React, { Suspense } from 'react';

import TeamCreateDialogLazyWrapper from './TeamCreateDialogLazyWrapper';
import { type AkTeamCreateDialogWrapperProps } from './types';

const TeamCreateDialogLazy = (props: AkTeamCreateDialogWrapperProps) => {
	return (
		<Suspense fallback={null}>
			<TeamCreateDialogLazyWrapper {...props} />
		</Suspense>
	);
};

export default TeamCreateDialogLazy;
